import { render, staticRenderFns } from "./ClientGroup.vue?vue&type=template&id=6ad5e50d&scoped=true&"
import script from "./ClientGroup.vue?vue&type=script&lang=js&"
export * from "./ClientGroup.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroup.vue?vue&type=style&index=0&id=6ad5e50d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5e50d",
  null
  
)

export default component.exports